import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var ChannelQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query channelQuery($storeId: String = \"\") {\n    channel(infoRequest: { params: [{ name: \"showCaseName\", value: $storeId }] }) {\n      name\n      data {\n        name\n        value\n      }\n    }\n  }\n"])));
export default ChannelQuery;